import { IconClicks } from '@lib/iab/iab-vast-model';

import createClick from './click';
import hasValue from '../util/has-value';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createIconClicks = ($iconClicks: UnmarshalerNode): IconClicks => {
    const iconClicks = new IconClicks();

    if (
        $iconClicks.iconClickThrough != null &&
        hasValue($iconClicks.iconClickThrough)
    ) {
        iconClicks.clickThrough = createClick(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $iconClicks.iconClickThrough as any
        );
    }

    if ($iconClicks.iconClickTracking != null) {
        iconClicks.clickTrackings.push(
            ...($iconClicks.iconClickTracking as UnmarshalerNode[])
                .filter(hasValue)
                .map((click: UnmarshalerNode) =>
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    createClick(click as any)
                )
        );
    }

    return iconClicks;
};

export default createIconClicks;
